import { Database } from "@copro/api";
import { DocumentDatabase, DocumentMinimalData } from "../../../../types";
import { useChangeDocumentsOfResource } from "../../../documents/hooks/useChangeDocumentsOfResource";
import { useUpdateSubjectAction } from "../../api/useUpdateSubjectAction";

export default function usePutActionAndDocuments(actionId: string | undefined, subjectId: string) {
  const { mutateAsync: putAction, isPending: isUpdated } = useUpdateSubjectAction();
  const { uploadPendingFiles, saveDocumentChanges, isPending: isUpdateDocumentsPending } = useChangeDocumentsOfResource();

  async function putActionAndDocuments(
    data: Database['public']['Tables']['subject_actions']['Update'],
    currentDocuments: DocumentDatabase[],
    documents: DocumentMinimalData[],
    providerId: string | null,
  ) {
    if (!actionId) {
      return;
    }

    // Upload files first — abort before updating the action if upload fails
    const uploadedDocuments = await uploadPendingFiles(documents, { subjectId });

    await putAction({
      id: actionId,
      command: data
    });

    const currentDocumentsIds = currentDocuments.map(d => d.id).sort().join(',');
    const newDocumentsIds = uploadedDocuments.map(d => d.id).sort().join(',');

    if (newDocumentsIds !== currentDocumentsIds) {
      await saveDocumentChanges(
        currentDocuments,
        uploadedDocuments,
        {
          subject_action_id: actionId,
          sub_topic_id: subjectId,
          provider_id: providerId,
        }
      );
    }
  }

  return {
    isLoading: isUpdated || isUpdateDocumentsPending,
    putActionAndDocuments
  }
}
